import { supabase } from './supabase';
import { publicAdditionalProducts } from './pod-collection.js';
import { podIntentFor } from './pod-products.js';
import { designFor } from './product-designs.js';
import { temporaryProductFor } from './temporary-product-photos.js';
import { brandProducts } from './brand-products.js';

export const DISPLAY_TEMPLATES = [
  ['glass_case', 'ガラスケース'], ['wall', '壁面展示'], ['pedestal', '台座'],
  ['hanger', 'ハンガー展示'], ['small_case', '小物ケース'], ['special', '特別展示'],
];
export const visibleState = (product, now = new Date()) => {
  const start = product.sale_start_at ? new Date(product.sale_start_at) : null;
  const end = product.sale_end_at ? new Date(product.sale_end_at) : null;
  if (product.stock_status === 'out_of_stock') return { label: 'SOLD OUT', buyable: false };
  if (start && now < start) return { label: `AVAILABLE ${start.toLocaleDateString('ja-JP',{month:'2-digit',day:'2-digit'})}`, buyable: false };
  if (end && now > end) return { label: 'ARCHIVED', buyable: false };
  // A concept-image approval cannot activate checkout, even via later CMS edits.
  if (temporaryProductFor(product.slug) || product.metadata?.previewOnly) return { label: 'COMING SOON', buyable: false };
  if (podIntentFor(product.slug)) {
    const design = designFor(product);
    if (!design.podSpec?.orderReady || design.photoSource !== 'printful') return { label: 'COMING SOON', buyable: false };
  }
  if (!product.purchase_url && !product.payment_price_id) return { label: 'COMING SOON', buyable: false };
  return { label: 'BUY', buyable: true };
};
export const assetFor = (product, preferred = ['exhibition','mockup','main']) => {
  const rows = [...(product.product_assets || [])].sort((a,b)=>a.display_order-b.display_order);
  for (const role of preferred) {
    const hit = rows.find(x => x.role === role && x.asset);
    if (hit) return hit.asset.public_url || '';
  }
  const first = rows.find(x => x.asset);
  return first ? (first.asset.public_url || '') : '';
};
const productSelect = `
  *,
  drop:drops(id,name,slug),
  exhibition:exhibitions(id,name,slug,theme,environment,display_order),
  product_assets(role,display_order,asset:assets(*))
`;
export async function loadMuseum(slug) {
  const fallback = () => ({ exhibition: { id: 'brand-area-001', name: 'AREA 001', slug: 'area-001' }, products: brandProducts });
  try {
  let q = supabase.from('exhibitions').select('*').eq('is_published', true).order('display_order');
  if (slug) q = q.eq('slug', slug);
  const { data: exhibitions, error: ee } = await q;
  if (ee) throw ee;
  const exhibition = exhibitions?.[0];
  if (!exhibition) return slug ? { exhibition: null, products: [] } : fallback();
  const { data: products, error } = await supabase.from('products')
    .select(productSelect).eq('exhibition_id', exhibition.id).eq('is_published', true).order('display_order');
  if (error) throw error;
  const rows = products || [];
  return { exhibition, products: rows.length ? [...rows, ...publicAdditionalProducts(exhibition, rows)] : brandProducts };
  } catch (error) {
    if (slug) throw error;
    return fallback();
  }
}
